export enum EBannerType {
  FSK = 'fsk',
}
